const SUPPORT_EMAIL = "support@paykit.africa";

export const contactSupport = (subject = "Support Request") => {
  window.location.href = `mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent(subject)}`;
};
